/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: firebase.config.js
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from "firebase/firestore";
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const FirebaseConfiguration = {
  apiKey: "AIzaSyB0D2WxE9ZCS5T04PAyis5KV-x8LwidqfQ",
  authDomain: "org-website-c36cf.firebaseapp.com",
  projectId: "org-website-c36cf",
  storageBucket: "org-website-c36cf.appspot.com",
  messagingSenderId: "845369856056",
  appId: "1:845369856056:web:ac685257eec72ed0c856cd"
};

const App = initializeApp(FirebaseConfiguration);
const Storage = getStorage(App); 
const StoreDB = getFirestore(App);

const FirebaseService = {
  App,
  Storage,
  StoreDB
}

export default FirebaseService;